import React from "react";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(7, 18, 15, 0.6)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  backdropFilter: "blur(4px)",
};

const cardStyle = {
  minWidth: 220,
  padding: "22px 26px",
  borderRadius: 18,
  background:
    "linear-gradient(180deg, rgba(15, 23, 20, 0.96), rgba(24, 37, 32, 0.96))",
  border: "1px solid rgba(138, 213, 184, 0.35)",
  boxShadow: "0 18px 48px rgba(0, 0, 0, 0.28)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 14,
  color: "#f4fff9",
  textAlign: "center",
};

const spinnerStyle = {
  width: 46,
  height: 46,
  borderRadius: "50%",
  border: "4px solid rgba(181, 245, 219, 0.18)",
  borderTopColor: "#8de3be",
  animation: "game-launch-spin 0.85s linear infinite",
};

function GameLaunchOverlay({ message = "กำลังเริ่มเกม..." }) {
  return (
    <div style={overlayStyle} role="status" aria-live="polite" aria-busy="true">
      <div style={cardStyle}>
        <div style={spinnerStyle} />
        <div style={{ fontSize: 18, fontWeight: 700 }}>{message}</div>
        <div style={{ fontSize: 13, opacity: 0.78 }}>
          กรุณารอสักครู่ ระบบกำลังพาเข้าสู่เกม
        </div>
      </div>
      <style>{`
        @keyframes game-launch-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default GameLaunchOverlay;
